import { render, staticRenderFns } from "./chatGroupList.vue?vue&type=template&id=0c0af32f&scoped=true"
import script from "./chatGroupList.vue?vue&type=script&lang=js"
export * from "./chatGroupList.vue?vue&type=script&lang=js"
import style0 from "./chatGroupList.vue?vue&type=style&index=0&id=0c0af32f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0af32f",
  null
  
)

export default component.exports